import { TOTAL_ROUNDS } from '../levels/levels.js';

/**
 * The status bar above the playfield. Kept in the DOM rather than the canvas
 * so screen readers and browser zoom treat it like real text.
 */

const formatScore = (value) => String(value).padStart(6, '0');

export function createHud(root) {
  const els = {
    score: root.querySelector('#hud-score'),
    high: root.querySelector('#hud-high'),
    round: root.querySelector('#hud-round'),
    roundName: root.querySelector('#hud-round-name'),
    lives: root.querySelector('#hud-lives'),
    livesCount: root.querySelector('#hud-lives-count'),
    announcer: root.querySelector('#announcer') || document.querySelector('#announcer'),
  };

  let lastLives = -1;
  let lastAnnouncement = '';

  return {
    update(session, highScore) {
      els.score.textContent = formatScore(session.score);
      els.high.textContent = formatScore(Math.max(highScore, session.score));
      els.round.textContent = `${session.round}/${TOTAL_ROUNDS}`;
      els.roundName.textContent = session.level?.name ?? '';

      if (session.lives !== lastLives) {
        lastLives = session.lives;
        renderLives(els.lives, session.lives);
        els.livesCount.textContent = `${session.lives} remaining`;
      }
    },

    /** Polite live-region message for players using a screen reader. */
    announce(message) {
      if (!els.announcer || message === lastAnnouncement) return;
      lastAnnouncement = message;
      els.announcer.textContent = message;
    },
  };
}

function renderLives(container, lives) {
  container.replaceChildren();
  for (let i = 0; i < lives; i += 1) {
    const pip = document.createElement('span');
    pip.className = 'life-pip';
    container.appendChild(pip);
  }
  if (lives === 0) {
    const pip = document.createElement('span');
    pip.className = 'life-pip life-pip--empty';
    container.appendChild(pip);
  }
}
